import { render, staticRenderFns } from "./PersonConfirmAlertCount.vue?vue&type=template&id=8e71d36c"
import script from "./PersonConfirmAlertCount.vue?vue&type=script&lang=js"
export * from "./PersonConfirmAlertCount.vue?vue&type=script&lang=js"
import style0 from "./PersonConfirmAlertCount.vue?vue&type=style&index=0&id=8e71d36c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports